import React from "react";
import { ExternalLink } from "lucide-react";
import { useDiaryContext } from "../../../../hooks/useDiaryContext";
import {
  configOptions,
  gridSizeOptions,
  updateGridConfig
} from "./ViewGridConfigController";
import { Switch } from "../../../ui/switch";
import { Slider } from "../../../ui/slider";
import { ToggleGroup, ToggleGroupItem } from "../../../ui/toggle-group";
import { EDSButton } from "../../../eds/EDSButton";

interface ViewGridConfigProps {
  closedAreasCount?: number;
  onCloseAreasClick?: () => void;
}

const ViewGridConfig = ({
  closedAreasCount = 0,
  onCloseAreasClick
}: ViewGridConfigProps) => {
  const { gridConfig, setDiaryContext } = useDiaryContext();

  return (
    <div className="space-y-4">
      {configOptions
        .filter((option) => option.key !== "displayNewCovers")
        .map((option) => (
          <div
            key={option.key}
            className="flex items-center justify-between gap-3"
          >
            <label className="text-sm font-medium text-foreground leading-none flex-1 min-w-0">
              {option.label}
            </label>
            <Switch
              checked={!!gridConfig[option.key]}
              onCheckedChange={(checked) => {
                updateGridConfig({
                  update: { [option.key]: checked },
                  gridConfig,
                  setDiaryContext
                });
              }}
            />
          </div>
        ))}
      <div className="space-y-2">
        <label
          htmlFor="covers-display"
          className="text-sm font-medium text-foreground leading-none"
        >
          Covers Display
        </label>
        <ToggleGroup
          type="single"
          value={gridConfig.displayNewCovers ? "new" : "total"}
          onValueChange={(value: string) => {
            if (value) {
              updateGridConfig({
                update: { displayNewCovers: value === "new" },
                gridConfig,
                setDiaryContext
              });
            }
          }}
          className="grid-config-toggle w-full"
          id="covers-display"
        >
          <ToggleGroupItem
            value="new"
            className="grid-config-toggle-item flex-1"
          >
            New Covers
          </ToggleGroupItem>
          <ToggleGroupItem
            value="total"
            className="grid-config-toggle-item flex-1"
          >
            Total Covers
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <EDSButton
        variant="outline"
        className="w-full justify-between"
        onClick={onCloseAreasClick}
      >
        <span>
          Close Areas {closedAreasCount > 0 && `(${closedAreasCount})`}
        </span>
        <ExternalLink className="h-4 w-4" />
      </EDSButton>
      <div className="space-y-2">
        <label
          htmlFor="grid-size"
          className="text-sm font-medium text-foreground leading-none"
        >
          Grid Size
        </label>
        <Slider
          value={[gridConfig.size]}
          onValueChange={(value) => {
            updateGridConfig({
              update: { size: value[0] },
              gridConfig,
              setDiaryContext
            });
          }}
          max={gridSizeOptions.length - 1}
          step={1}
          className="w-full"
          id="grid-size"
        />
      </div>
    </div>
  );
};

export default ViewGridConfig;
